import { render, staticRenderFns } from "./work-list-import-list.vue?vue&type=template&id=480863c8&scoped=true"
import script from "./work-list-import-list.vue?vue&type=script&lang=ts"
export * from "./work-list-import-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480863c8",
  null
  
)

export default component.exports